import { DISABLED_OPACITY } from "../../../../styles/colors/consts";
import { KeyColorRole } from "../../../../styles/colors/types";
import {
  Display,
  ResponsiveDimension,
  ResponsiveProp
} from "../../../../types";
import { IconButtonFill, IconButtonSize, sizeMap } from "../consts";
import useIconButtonColorStyleProps from "./useIconButtonColorStyleProps";

const staticStyleProps = {
  display: "block" as ResponsiveProp<Display>,
  borderRadius: "xxlarge" as ResponsiveDimension
};

export default function useGetIconButtonStyles({
  tone,
  disabled,
  blend,
  size,
  fill
}: {
  tone: KeyColorRole;
  disabled: boolean;
  blend: boolean;
  size?: IconButtonSize;
  fill: IconButtonFill;
}) {
  const cursor = disabled ? "not-allowed" : "pointer";
  const opacity = disabled ? DISABLED_OPACITY : "1";

  const filledButtonColorStyleProps = useIconButtonColorStyleProps({
    tone,
    disabled,
    blend,
    fill
  });

  const circleSize = size ? sizeMap[size].circleSize : undefined;

  return {
    ...staticStyleProps,
    cursor,
    opacity,
    ...filledButtonColorStyleProps,
    borderWidth: blend ? undefined : ("xxxsmall" as const),
    borderStyle: blend ? undefined : ("solid" as const),
    height: circleSize,
    width: circleSize
  };
}
